
import Modul, {ModuleData} from './Modul';
import {BackgroundSettingsPayload} from "./section/index";
import AppRegistry from 'diy/AppRegistry';
import {loadData, ConfigurableGroup} from './sectionContainer/index';

function getStore() {
    return AppRegistry.getStoreProvider().getStore();
}

export interface SectionContainerData extends ModuleData {
    background: BackgroundSettingsPayload;
    configurable: ConfigurableGroup;
}

export default class ModulSectionContainer extends Modul {
    data: SectionContainerData;
    constructor(moduleId: number) {
        super(moduleId);
        this.freezeOverlay(true);
    }

    loadData(data: SectionContainerData) {
        super.loadData(data);

        getStore().dispatch(loadData({ moduleId: this.moduleId, data: this.data }));
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulSectionContainer.ts
 **/